import { render, staticRenderFns } from "./TabletHeader.vue?vue&type=template&id=6169a40b&"
import script from "./TabletHeader.vue?vue&type=script&lang=js&"
export * from "./TabletHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabletHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports